/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { Card, PageState } from '@myob/myob-widgets';
import somethingWentWrong from 'assets/images/somethingWentWrong.svg';
import { RootState } from 'stores';
import { IProductsState } from 'modules/ProductManagement/reducers/type';
import { getFormattedSupportNumber, getSupportNumber } from '../../helper';

const ErrorComponent: React.FC = () => {
    const { region } = useSelector<RootState, IProductsState>(state => state.productManagement.products);
    const phoneNumber = getSupportNumber(region);
    const formattedSupportNumber = getFormattedSupportNumber(region);

    return (
        <section>
            <Card>
                <PageState
                    title="Something went wrong"
                    image={<img src={somethingWentWrong} alt="Something Went Wrong" />}
                    description={
                        <p role="note" id="manage-my-product-page-error-page">
                            Try reloading the page. If the issue persists, contact MYOB support on{' '}
                            <a href={`tel:${phoneNumber}`} id="manage-my-product-support-phone-number">
                                {formattedSupportNumber}
                            </a>
                            .
                        </p>
                    }
                />
            </Card>
        </section>
    );
};

export default ErrorComponent;
